import {IExecuteWaitForHybridGameStepOptions, IHybridService} from "./hybrid.service.interface";
import {ServiceBase} from "../ServiceBase";
import {NullableUndefinedString} from "../../../common/types/nullable-types";

export class HybridService extends ServiceBase implements IHybridService {
    prepareGameUrl(gameType: number, gameUrl: string, pathname: string = ''): string {
        return this.services.sdk.hybrid.prepareGameUrl(gameType, gameUrl, pathname);
    }

    getCompiledGameVersion(gameType: number): NullableUndefinedString {
        return this.services.sdk.hybrid.getCompiledGameVersion(gameType);
    }

    async executeWaitForHybridGameStep(options: IExecuteWaitForHybridGameStepOptions): Promise<void> {
        await this.services.sdk.hybrid.executeWaitForHybridGameStep(options);
    }

    navigateToOnDemandStandalone(gameType: number, companyName: string, url: string): boolean {
        return this.services.sdk.hybrid.navigateToOnDemandStandalone(gameType, companyName, url);
    }
    isNativeSupportSecondWebView(): boolean {
        return this.services.sdk.hybrid.isNativeSupportSecondWebView();
    }

    isOnDemandHtmlGame(gameType: number): boolean {
        return this.services.sdk.hybrid.isOnDemandHtmlGame(gameType);
    }

    isOnDemandStandalone(gameType: number, companyName: string): boolean {
        return this.services.sdk.hybrid.isOnDemandStandalone(gameType, companyName);
    }

    getOnDemandOrigin(): string {
        return this.services.sdk.hybrid.getOnDemandOrigin();
    }

    showAlert(message: string): void {
        this.services.sdk.eventsTrigger.showHybridAlert(message);
    }
}